import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Constants } from '../lib/const/constants';
import { getCurrencySymbol } from '../lib/currenyUtils';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CURRENCIES } from '../lib/currencies';
import { encryptPayload } from '../utils/encryption';

function DashboardTransferCalculator() {
  const navigate = useNavigate();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [receiveDropdownOpen, setReceiveDropdownOpen] = useState(false);
  const [selectedReceiveCurrency, setSelectedReceiveCurrency] = useState(null);

  const [receiveCurrency, setReceiveCurrency] = useState('');
  const [receiveCurrencyValue, setReceiveCurrencyValue] = useState('');
  const [, setReceiveCurrencyFlag] = useState('');

  const [, setLoading] = useState(false);
  const [balLoading, setBalLoading] = useState(false);
  const [amount, setAmount] = useState('');
  const [type, settype] = useState('sell');
  const ref = useRef(null);

  const [convertloading, setConvertLoading] = useState(false);
  const [buyAmount, setBuyAmount] = useState('');
  const [exchangeRate, setexchangeRate] = useState(0);
  const [convertDate, setConvertDate] = useState('');
  const [contactId, setContactId] = useState('');
  const [recentEdit, setrecentEdit] = useState('sell');
  const [currency, setCurrency] = useState('');
  const [currencyid, setCurrencyId] = useState('');
  const [, setBalance] = useState();
  const [, setreceivebalance] = useState();
  const [usedBalances, setusedBalances] = useState([]);
  const [, setclearBankBalance] = useState(0.0);
  const [, setcurrencyCloudBalance] = useState(0.0);
  const [balances, setBalances] = useState([]);
  const [, setRecentLoaded] = useState();
  const [, setclearBankConfiguration] = useState();
  const [, setreceivingCurrency] = useState();
  const [, setreference] = useState();
  const [buyCurrency, setBuyCurrency] = useState('');
  const [sellCurrency, setSellCurrency] = useState('');

  const timeout = useRef(null);

  useEffect(() => {
    const handler = () => {
      setDropdownOpen(false);
      setReceiveDropdownOpen(false);
    };
    document.addEventListener('click', handler);
    return () => document.removeEventListener('click', handler);
  }, []);

  useEffect(() => {
    if (ref.current) return;
    ref.current = true;
    getBalances();
    getData();
    removeData();
  }, []);

  const getData = async () => {
    setLoading(true);
    settype('sell');
    const token = sessionStorage.getItem('login_token');
    const defaultBank = sessionStorage.getItem('defaultBank');
    const parsedWorkspace = JSON.parse(sessionStorage.getItem('login_workspaces'));
    if(!parsedWorkspace){
      return;
    }
    var refVal = '';
    if (defaultBank === 'Clear Bank as Service') {
      console.log('cb');
    } else {
      if (Object.keys(parsedWorkspace[0].accounts).length > 0) {
        console.log('cc');
      } else {
        refVal = JSON.parse(sessionStorage.getItem('login_workspaces'))[0].memberships.urn;
        setreference(refVal);
      }
    }
    if (refVal === '') {
      await axios
        .get(Constants.BASE_URL + 'API-FX-162-CONVERTCOUNTRIES', {
          headers: { Authorization: 'Bearer ' + JSON.parse(token), fx_key: Constants.SUBSCRIPTION_KEY },
        })
        .then(() => { setLoading(false);})
        .catch(() => { setLoading(false); });
    } else {
      setLoading(false);
    }
  };

  const getBalances = async () => {
    setBalLoading(true);
    const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
    const login_token = sessionStorage.getItem('login_token');
    try {
      const resp = await axios.get(
        Constants.BASE_URL + 'API-FX-231-GET-WALLET-BALANCES/' + login_workspaces_id,
        { headers: { Authorization: 'Bearer ' + JSON.parse(login_token), fx_key: Constants.SUBSCRIPTION_KEY } },
      );
      const balArray = Object.values(resp.data);

      setusedBalances(resp.data.used_balances);
      balArray.pop();
      setcurrencyCloudBalance(resp.data.currency_cloud_account_balance);
      setclearBankBalance(resp.data.clear_bank_account_balance);
      setclearBankConfiguration(resp.data.fees_configuration);
      balArray.pop(); balArray.pop(); balArray.pop();

      if (balArray.length > 0) {
        setBalances((prev) => [...prev, ...balArray]);
        if (balArray.length === 1) {
          balArray.push({
            id: 3, currency: 'INR', balance: 0,
            meta: { code: 'IN', name: 'India', country_id: 105, flag: 'https://uat.dhigna.com/flags/IN.PNG' },
            created_at: '2025-06-28T08:23:31.170932Z', updated_at: '2025-06-28T08:23:31.170935Z',
          });
        }

        const lastSell = sessionStorage.getItem('last_sell_currency');
        const lastBuy  = sessionStorage.getItem('last_buy_currency');

        if (lastSell) {
          const sellMatch = balArray.find((b) => b.currency === lastSell);
          if (sellMatch) {
            const flagUrl = getFlagUrl(sellMatch);
            setSelectedCurrency({ currency: sellMatch.currency, currencyid: sellMatch?.meta?.country_id, flag: flagUrl });
            setCurrency(sellMatch.currency);
            setCurrencyId(sellMatch?.meta?.country_id);
          }
        }
        if (lastBuy) {
          const buyMatch = balArray.find((b) => b.currency === lastBuy);
          if (buyMatch) {
            const flagUrl = getFlagUrl(buyMatch);
            setSelectedReceiveCurrency({ currency: buyMatch.currency, currencyid: buyMatch?.meta?.country_id, flag: flagUrl });
            setReceiveCurrency(buyMatch?.meta?.country_id);
            setReceiveCurrencyValue(buyMatch.currency);
          }
        }
        await getLastConversion(balArray);

      } else {
        const defaultBank = sessionStorage.getItem('defaultBank');
        const parsedWorkspace = JSON.parse(sessionStorage.getItem('login_workspaces'));
        var refVal = '';
        if (defaultBank === 'Clear Bank as Service') {
          console.log('cb');
        } else {
          if (Object.keys(parsedWorkspace[0].accounts).length > 0) {
            console.log('cc');
          } else {
            refVal = JSON.parse(sessionStorage.getItem('login_workspaces'))[0].memberships.urn;
            setreference(refVal);
          }
        }
        if (refVal !== '') { setBalances(Constants.INDIVIDUAL_BALANCES_CURRENCIES); }
      }
      setBalLoading(false);
    } catch (err) {
      console.log(err?.response?.data);
      setBalLoading(false);
    } finally {
      setBalLoading(false);
    }
  };

  const getLastConversion = async (balArray) => {
    try {
      const login_token = sessionStorage.getItem('login_token');
      const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
      const from =
        new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + (new Date().getDate() - 100);
      const to =
        new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate();

      const response = await axios.get(
        `${Constants.BASE_URL}API-FX-180-CONVERSIONLIST/${login_workspaces_id}?page=0&from=${from}&to=${to}`,
        {
          headers: {
            Authorization: 'Bearer ' + JSON.parse(login_token),
            fx_key: Constants.SUBSCRIPTION_KEY,
          },
        }
      );

      const conversions = response.data.data || [];
      if (conversions.length === 0) {
        const gbpMatch = balArray.find(b => b.currency === 'GBP');
        if (gbpMatch) {
          const flagUrl = getFlagUrl(gbpMatch);
          setSelectedCurrency({ currency: 'GBP', currencyid: gbpMatch?.meta?.country_id, flag: flagUrl });
          setCurrency('GBP');
          setCurrencyId(gbpMatch?.meta?.country_id);
          setAmount('1');

          // pick a default receive currency (first one that isn't GBP)
          const defaultReceive = balArray.find(b => b.currency !== 'GBP');
          if (defaultReceive) {
            const receiveFlagUrl = getFlagUrl(defaultReceive);
            setSelectedReceiveCurrency({ currency: defaultReceive.currency, currencyid: defaultReceive?.meta?.country_id, flag: receiveFlagUrl });
            setReceiveCurrency(defaultReceive?.meta?.country_id);
            setReceiveCurrencyValue(defaultReceive.currency);
            await getConversionData('1', defaultReceive?.meta?.country_id, gbpMatch?.meta?.country_id);
          }
        }
        return;
      }

      const latest = conversions[0];
      const meta = JSON.parse(latest.meta);

      const sellCur   = meta.client_sell_currency;  
      const sellAmt   = meta.client_sell_amount;     
      const buyCur    = meta.client_buy_currency;    
      const sellCurId = meta.currency_sell;          
      const buyCurId  = meta.currency_buy;          

      const sellMatch = balArray.find(b => b.currency === sellCur);
      if (sellMatch) {
        const flagUrl = getFlagUrl(sellMatch);
        setSelectedCurrency({ currency: sellCur, currencyid: sellCurId, flag: flagUrl });
        setCurrency(sellCur);
        setCurrencyId(sellCurId);
        setAmount(String(sellAmt));
      }

      const buyMatch = balArray.find(b => b.currency === buyCur);
      if (buyMatch) {
        const flagUrl = getFlagUrl(buyMatch);
        setSelectedReceiveCurrency({ currency: buyCur, currencyid: buyCurId, flag: flagUrl });
        setReceiveCurrency(buyCurId);
        setReceiveCurrencyValue(buyCur);
      }

      if (sellCurId && buyCurId && sellAmt) {
        await getConversionData(String(sellAmt), buyCurId, sellCurId);
      }
    } catch (err) {
      console.warn('Could not prefill from last conversion:', err);
    }
  };

  const getConversionData = async (amt, currencyReceive, sellCurrencyIdOverride) => {
    try {
      const token = sessionStorage.getItem('login_token');
      const staff_login_id = sessionStorage.getItem('staff_login_id');
      const workspaceId = sessionStorage.getItem('login_workspaces_id');
      const activeSellCurrencyId = sellCurrencyIdOverride ?? currencyid;
      if (!currencyReceive || !amt || amt == 0) { setConvertLoading(false); return; }
      setexchangeRate(0);
      setConvertLoading(true);
      let convertamount = amt || amount;
      setAmount(convertamount);
      if (activeSellCurrencyId === currencyReceive) { toast.error('Same currency cannot be converted.'); setConvertLoading(false); return; }
      else if (activeSellCurrencyId == 105) { toast.error('Currency not supported.'); setConvertLoading(false); return; }
      setreceivingCurrency(currencyReceive);

      const encryptedPayload = await encryptPayload({ sell_currency_country_id: activeSellCurrencyId, buy_currency_country_id: currencyReceive, amount: parseFloat(convertamount).toFixed(2), workspace_id: workspaceId, type: type, staff_login_id: staff_login_id,platform: 'web', extraParamValidation: 'trustedfromweb' });
      const response = await axios.post(
        Constants.BASE_URL + 'API-FX-163-CONVERTRATES',
        encryptedPayload,
        { headers: { fx_key: Constants.SUBSCRIPTION_KEY, Authorization: 'Bearer ' + JSON.parse(token) } },
      );
      if (response.data && response.data.code !== 400 && response.data.success !== false) {
        setRecentLoaded('normal');
        setBuyAmount(parseFloat(response.data.data.meta.client_buy_amount).toFixed(2  ));
        setAmount(parseFloat(response.data.data.meta.client_sell_amount).toFixed(2));
        setexchangeRate(parseFloat(response.data.data.meta.client_rate));
        const updatedate = new Date(response.data.data.updated_at);
        setConvertDate(`${updatedate.getDate()}-${updatedate.getMonth() + 1}-${updatedate.getFullYear()}`);
        setContactId(response.data.contact_id);
        setBuyCurrency(response.data.data.meta.client_buy_currency);
        setSellCurrency(response.data.data.meta.client_sell_currency);
        sessionStorage.setItem('last_sell_currency', response.data.data.meta.client_sell_currency);
        sessionStorage.setItem('last_buy_currency', response.data.data.meta.client_buy_currency);
      } else {
        toast.error(response.data.message || 'Rate could not be retrieved.');
      }
    } catch (error) {
      console.error('Error during getConversionData:', error);
      toast.error(error?.response?.data?.message || 'Error retrieving conversion rate.');
    } finally {
      setConvertLoading(false);
    }
  };

  const getInverseConversionData = async (amt, currencyReceive, sellCurrencyIdOverride) => {
    const token = sessionStorage.getItem('login_token');
    const staff_login_id = sessionStorage.getItem('staff_login_id');
    const activeSellCurrencyId = sellCurrencyIdOverride ?? currencyid;
    if (currencyReceive != '' && currencyReceive != null && amt != '' && amt != 0) {
      setConvertLoading(true);
      var convertamount = parseFloat(buyAmount).toFixed(2);
      if (amt === '' || amt == null) { convertamount = buyAmount; setBuyAmount(buyAmount); }
      else { convertamount = amt; setBuyAmount(amt); }
      const workspaceId = sessionStorage.getItem('login_workspaces_id');
      if (convertamount !== '' && convertamount != null) {
        if (activeSellCurrencyId == currencyReceive) {
          toast.error('Same currency cannot be converted.');
        } else if (activeSellCurrencyId == 105) {
          toast.error('Currency not supported.');
          setConvertLoading(false);
          return;
        } else {
          setRecentLoaded('inverse');
          setreceivingCurrency(currencyReceive);
          if (activeSellCurrencyId !== '' && activeSellCurrencyId != null && currencyReceive !== '' && currencyReceive != null) {
            const encryptedPayload = await encryptPayload({
                      sell_currency_country_id: activeSellCurrencyId, buy_currency_country_id: currencyReceive, amount: parseFloat(convertamount).toFixed(2), workspace_id: workspaceId, type: 'buy', staff_login_id: staff_login_id,
                      platform: 'web',
                      extraParamValidation: 'trustedfromweb'
                    });

            await axios
              .post(
                Constants.BASE_URL + 'API-FX-163-CONVERTRATES',
                encryptedPayload,
                { headers: { fx_key: Constants.SUBSCRIPTION_KEY, Authorization: 'Bearer ' + JSON.parse(token) } },
              )
              .then((resp) => {
                if (resp.data.code != 400) {
                  setBuyAmount(parseFloat(resp.data.data.meta.client_buy_amount).toFixed(2));
                  setAmount(parseFloat(resp.data.data.meta.client_sell_amount).toFixed(2));
                  setexchangeRate(parseFloat(resp.data.data.meta.client_rate));
                  setBuyCurrency(resp.data.data.meta.client_buy_currency);
                  setSellCurrency(resp.data.data.meta.client_sell_currency);
                  sessionStorage.setItem('last_sell_currency', resp.data.data.meta.client_sell_currency);
                  sessionStorage.setItem('last_buy_currency', resp.data.data.meta.client_buy_currency);
                  const updatedate = new Date(resp.data.data.updated_at);
                  setConvertDate(updatedate.getDate() + '-' + (+updatedate.getMonth() + 1) + '-' + updatedate.getFullYear());
                  setContactId(resp.data.contact_id);
                } else {
                  toast.success(resp.data.message);
                }
                setConvertLoading(false);
              })
              .catch((error) => { toast.error(error.response.data.message); setConvertLoading(false); });
          }
        }
      }
    }
    setConvertLoading(false);
  };

  const removeData = async () => {
    sessionStorage.removeItem('sell');
    sessionStorage.removeItem('buy');
  };

  const onChangeHandler = (value) => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => { getConversionData(value, receiveCurrency); }, 2000);
  };

  const onInverseChangeHandler = (value) => {
    clearTimeout(timeout.current);
    timeout.current = setTimeout(() => { getInverseConversionData(value, receiveCurrency); }, 2000);
  };

  const getFlagUrl = (resp) => {
    switch (resp.currency) {
      case 'EUR': return `${Constants.FXMASTER_BASE_URL}flags/eu.png`;
      case 'RON': return `${Constants.FXMASTER_BASE_URL}flags/ro.png`;
      case 'DKK': return `${Constants.FXMASTER_BASE_URL}flags/dk.png`;
      case 'NOK': return `${Constants.FXMASTER_BASE_URL}flags/no.png`;
      case 'SEK': return `${Constants.FXMASTER_BASE_URL}flags/se.png`;
      case 'MYR': return `${Constants.FXMASTER_BASE_URL}flags/my.png`;
      default: return `${Constants.FXMASTER_BASE_URL}flags/${resp?.meta?.flag?.split('/').pop()}`;
    }
  };

  const dropdownStyle = {
    maxHeight: '200px',
    overflowY: 'scroll',
    scrollbarWidth: 'thin',
    msOverflowStyle: 'auto',
    WebkitOverflowScrolling: 'touch',
  };

  if (balLoading) {
    return (
      <div style={cardStyle}>
        <div style={{ height: 20, width: '60%', background: '#e2e8f0', borderRadius: 6, marginBottom: 12 }} />
        <div style={{ height: 32, width: '80%', background: '#e2e8f0', borderRadius: 6, marginBottom: 24 }} />
        <div style={{ height: 52, background: '#e2e8f0', borderRadius: 10, marginBottom: 12 }} />
        <div style={{ height: 40, width: 40, background: '#e2e8f0', borderRadius: '50%', margin: '8px auto' }} />
        <div style={{ height: 52, background: '#e2e8f0', borderRadius: 10, marginBottom: 20 }} />
        <div style={{ height: 48, background: '#e2e8f0', borderRadius: 10 }} />
      </div>
    );
  }

  return (
    <div style={cardStyle}>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

      <h3 style={{ fontSize: '24px', fontWeight: 600, color: '#1D2338', marginBottom: '1rem', marginTop: 0, lineHeight: '32px', letterSpacing: '0px' }}>
        Transfer calculator
      </h3>

      <div style={rateBannerStyle}>
        <span style={{ fontSize: '14px', fontWeight: '400', color: '#4A5565', display: 'block', marginBottom: 2 }}>Exchange Rate</span>
        {convertloading ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={spinnerStyle} />
            <span style={{ fontSize: '0.85rem', color: '#94a3b8' }}>Fetching best rate...</span>
          </div>
        ) : (
          <span style={{ fontSize: '18px', fontWeight: 600, color: '#101828' }}>
            {exchangeRate > 0
              ? `1 ${sellCurrency} = ${parseFloat(exchangeRate).toFixed(4)} ${buyCurrency}`
              : '—'}
          </span>
        )}
      </div>

      <div style={{ marginBottom: 4 }}>
        <label style={labelStyle}>Sell</label>
        <div style={inputRowStyle}>
          
          <div style={{ position: 'relative', flex: 1 }}>
            <span style={currSymbolStyle}>
              {currency && getCurrencySymbol(currency)}
            </span>
            <input
              value={amount}
              type="number"
              min="0"
              onKeyDown={(e) => { if (e.key === '-' || e.key === 'e') e.preventDefault(); }}
              placeholder="1.00"
              style={{ ...inputStyle, paddingLeft: currency ? 28 : 12 }}
              onChange={(e) => {
                const value = e.target.value;
                const validated = value.match(/^(\d*\.{0,1}\d{0,2})$/);
                if (validated) setAmount(validated[0]);
                setConvertLoading(true);
                if (e.target.value === '') setBuyAmount('');
                onChangeHandler(e.target.value);
                setrecentEdit('sell');
              }}
            />
          </div>

          <div
            style={currencySelectorStyle}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setDropdownOpen(!dropdownOpen); setReceiveDropdownOpen(false); }}
          >
            {selectedCurrency ? (
              <>
                <img src={selectedCurrency.flag} alt="flag" style={flagStyle} />
                <span style={currCodeStyle}>{selectedCurrency.currency}</span>
              </>
            ) : (
              <span style={{ fontSize: '0.85rem', color: '#94a3b8' }}>Select</span>
            )}
            <span style={{ fontSize: '0.7rem', color: '#94a3b8', marginLeft: 2 }}>▾</span>

            {dropdownOpen && (
              <div style={{ ...dropdownStyle, ...dropdownContainerStyle }} onClick={(e) => e.stopPropagation()}>
                {balances.map((resp, index) => {
                  const flagUrl = getFlagUrl(resp);
                  const data = { currency: resp.currency, currencyid: resp?.meta?.country_id, flag: flagUrl };
                  return (
                    <div
                      key={index}
                      style={dropdownItemStyle}
                      onMouseEnter={(e) => e.currentTarget.style.background = '#f1f5f9'}
                      onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                      onClick={async (e) => {
                        e.preventDefault(); e.stopPropagation();
                        try {
                          setDropdownOpen(false);
                          setSelectedCurrency(data);
                          setCurrency(resp.currency);
                          const newSellCurrencyId = resp?.meta?.country_id;
                          setCurrencyId(newSellCurrencyId);
                          setConvertLoading(true);
                          if (recentEdit === 'sell') await getConversionData(amount, receiveCurrency, newSellCurrencyId);
                          else await getInverseConversionData(amount, receiveCurrency, newSellCurrencyId);
                          balances.forEach((row) => {
                            if (row.currency === resp.currency) {
                              const used = usedBalances[resp.currency] || 0;
                              const final = row.balance - used;
                              setBalance(final < 0 ? 0 : final);
                            }
                          });
                        } catch (err) { console.error('Error while changing currency:', err); }
                      }}
                    >
                      <img src={flagUrl} alt="flag" style={{ width: 18, height: 18, borderRadius: '50%', flexShrink: 0 }} />
                      <span style={{ fontSize: '0.82rem', fontWeight: 600, color: '#0B214E', flexShrink: 0 }}>{resp.currency}</span>
                      <span style={{ fontSize: '0.75rem', color: '#94a3b8', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{CURRENCIES[resp.currency]}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', margin: '10px 0' }}>
        <button
          type="button"
          style={swapBtnStyle}
          onMouseEnter={(e) => { e.currentTarget.style.background = '#e2e8f0'; e.currentTarget.style.transform = 'rotate(180deg) scale(1.08)'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = '#f1f5f9'; e.currentTarget.style.transform = 'rotate(0deg) scale(1)'; }}
          onClick={async () => {
            const tempCurrency = currency;
            const tempCurrencyId = currencyid;
            const tempSelectedCurrency = selectedCurrency;
            const tempReceiveCurrency = receiveCurrency;
            const tempReceiveCurrencyValue = receiveCurrencyValue;
            const tempSelectedReceiveCurrency = selectedReceiveCurrency;
            const tempAmount = amount;
            const tempBuyAmount = buyAmount;
            setCurrency(tempReceiveCurrencyValue);
            setCurrencyId(tempReceiveCurrency);
            setSelectedCurrency(tempSelectedReceiveCurrency);
            setReceiveCurrency(tempCurrencyId);
            setReceiveCurrencyValue(tempCurrency);
            setSelectedReceiveCurrency(tempSelectedCurrency);
            setAmount(tempBuyAmount);
            setBuyAmount(tempAmount);
            if (tempReceiveCurrency && tempCurrencyId && tempBuyAmount) {
              await getConversionData(tempBuyAmount, tempCurrencyId, tempReceiveCurrency);
            }
          }}
        >
          ⇅
        </button>
      </div>

      <div style={{ marginBottom: 20 }}>
        <label style={labelStyle}>Buy</label>
        <div style={inputRowStyle}>
          
          <div style={{ position: 'relative', flex: 1 }}>
            <span style={currSymbolStyle}>
              {receiveCurrencyValue && getCurrencySymbol(receiveCurrencyValue)}
            </span>
            <input
              value={buyAmount}
              type="number"
              min="0"
              onKeyDown={(e) => { if (e.key === '-' || e.key === 'e') e.preventDefault(); }}
              placeholder="0.00"
              style={{ ...inputStyle, paddingLeft: receiveCurrencyValue ? 28 : 12 }}
              onChange={(e) => {
                const value = e.target.value;
                if (value.startsWith('-')) return;
                const validated = value.match(/^(\d*\.{0,1}\d{0,2})$/);
                if (validated) setBuyAmount(validated[0]);
                setConvertLoading(true);
                if (e.target.value === '') setAmount('');
                onInverseChangeHandler(e.target.value);
                setrecentEdit('buy');
              }}
            />
          </div>

          <div
            style={currencySelectorStyle}
            onClick={(e) => { e.preventDefault(); e.stopPropagation(); setReceiveDropdownOpen(!receiveDropdownOpen); setDropdownOpen(false); }}
          >
            {selectedReceiveCurrency ? (
              <>
                <img src={selectedReceiveCurrency.flag} alt="flag" style={flagStyle} />
                <span style={currCodeStyle}>{selectedReceiveCurrency.currency}</span>
              </>
            ) : (
              <span style={{ fontSize: '0.85rem', color: '#94a3b8' }}>Select</span>
            )}
            <span style={{ fontSize: '0.7rem', color: '#94a3b8', marginLeft: 2 }}>▾</span>

            {receiveDropdownOpen && (
              <div style={{ ...dropdownStyle, ...dropdownContainerStyle }} onClick={(e) => e.stopPropagation()}>
                {balances.map((resp, index) => {
                  if (currency === resp.currency) return null;
                  const flagUrl = getFlagUrl(resp);
                  const data = { currency: resp.currency, currencyid: resp?.meta?.country_id, flag: flagUrl };
                  return (
                    <div
                      key={index}
                      style={dropdownItemStyle}
                      onMouseEnter={(e) => e.currentTarget.style.background = '#f1f5f9'}
                      onMouseLeave={(e) => e.currentTarget.style.background = 'transparent'}
                      onClick={async (e) => {
                        e.preventDefault(); e.stopPropagation();
                        try {
                          setReceiveDropdownOpen(false);
                          setSelectedReceiveCurrency(data);
                          setReceiveCurrency(resp?.meta?.country_id);
                          setReceiveCurrencyValue(resp.currency);
                          setReceiveCurrencyFlag(flagUrl);
                          setConvertLoading(true);
                          if (recentEdit === 'sell') { await getConversionData(amount, resp?.meta?.country_id); }
                          else { await getInverseConversionData(amount, resp?.meta?.country_id); }
                          balances.forEach((row) => {
                            if (row.currency === resp.currency) {
                              const used = usedBalances[resp.currency] || 0;
                              const final = row.balance - used;
                              setreceivebalance(final < 0 ? 0 : final);
                            }
                          });
                        } catch (err) { console.error('Error while changing receive currency:', err); }
                      }}
                    >
                      <img src={flagUrl} alt="flag" style={{ width: 18, height: 18, borderRadius: '50%', flexShrink: 0 }} />
                      <span style={{ fontSize: '0.82rem', fontWeight: 600, color: '#0B214E', flexShrink: 0 }}>{resp.currency}</span>
                      <span style={{ fontSize: '0.75rem', color: '#94a3b8', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{CURRENCIES[resp.currency]}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>

      <button
        type="button"
        disabled={!exchangeRate || convertloading}
        style={{
          ...convertBtnStyle,
          opacity: (!exchangeRate || convertloading) ? 0.65 : 1,
          cursor: (!exchangeRate || convertloading) ? 'not-allowed' : 'pointer',
        }}
        onMouseEnter={(e) => { if (exchangeRate && !convertloading) e.currentTarget.style.background = '#b45309'; }}
        onMouseLeave={(e) => { e.currentTarget.style.background = '#d97706'; }}
        onClick={() => {
          if (!exchangeRate || convertloading) return;
          navigate('/review', {
            state: {
              sellCurrency,
              buyCurrency,
              exchangeRate,
              convertDate,
              amount,
              buyAmount,
              contactId,
              from_currency: currency,
              receiveCurrencyValue,
              receiveCurrencyId: receiveCurrency,
              sellFlagUrl: selectedCurrency?.flag || '',
              buyFlagUrl: selectedReceiveCurrency?.flag || '',
            },
          });
        }}
      >
        {convertloading ? (
          <span style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'center' }}>
            <div style={{ ...spinnerStyle, borderColor: 'rgba(255,255,255,0.3)', borderTopColor: '#fff' }} />
            Fetching rate...
          </span>
        ) : 'Convert Now'}
      </button>

      <div style={securityNoteStyle}>
        <div style={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          background: '#dbeafe',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}>
          <span style={{ fontSize: '1.0rem', color: '#3b82f6' }}>i</span>
        </div>
        <div>
          <p style={{ margin: 0, fontSize: '14px', fontWeight: 600, color: '#1C398E' }}>Your money, protected</p>
          <p style={{ margin: 0, fontSize: '12px', fontWeight: 400, color: '#1447E6CC', marginTop: 4 }}>
            Built with cutting-edge security and always-on support to keep your money moving safely.
          </p>
        </div>
      </div>
    </div>
  );
}

const cardStyle = {
  width: '100%',
  height: 598,
  borderRadius: 16,
  padding: 24,
  gap: 24,
  boxSizing: 'border-box',
  position: 'relative',
  opacity: 1,

  background: 'rgba(255, 255, 255, 0.7)',

  border: '1px solid #E5E7EB',
  borderTop: '1px solid #E5E7EB80',

  boxShadow:
    '0px 4px 6px -4px rgba(229,231,235,0.5), 0px 10px 15px -3px rgba(229,231,235,0.5)',
};

const rateBannerStyle = {
  width: '100%',
  height: 76,
  borderRadius: 16,
  padding: '12px 20px',
  marginBottom: '20px',
  marginTop: '10px',

  background: 'linear-gradient(135deg, rgba(239, 246, 255, 0.8) 0%, rgba(238, 242, 255, 0.5) 100%)',

  border: '1px solid #e2e8f0',
  borderTop: '1px solid #BEDBFF4D',

  boxShadow:
    '0px 1px 2px -1px rgba(0,0,0,0.1), 0px 1px 3px 0px rgba(0,0,0,0.1)',
};

const labelStyle = {
  display: 'block',
  fontSize: '14px',
  fontWeight: 700,
  color: '#364153',
  lineHeight: '20px',
  letterSpacing: '0px',
  marginBottom: 6,
};

const inputRowStyle = {
  width: '100%',
  height: 56,
  borderRadius: 12,
  padding: 16,

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  background: 'rgba(255, 255, 255, 0.5)',

  border: '2px solid #E5E7EB',
  borderTop: '2px solid #E5E7EB80',

  boxShadow:
    '0px 1px 2px -1px rgba(0,0,0,0.1), 0px 1px 3px 0px rgba(0,0,0,0.1)',

  opacity: 1,
};

const inputStyle = {
  width: '100%',
  height: 48,
  border: 'none',
  outline: 'none',
  background: 'transparent',
  fontSize: '1rem',
  fontWeight: 600,
  color: '#0B214E',
  paddingRight: 8,
  boxSizing: 'border-box',
};

const currSymbolStyle = {
  position: 'absolute',
  left: 10,
  top: '50%',
  transform: 'translateY(-50%)',
  fontSize: '18px',
  color: '#0A0A0A',
  fontWeight: 600,
  pointerEvents: 'none',
  zIndex: 1,
};

const currencySelectorStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  padding: '0 12px',
  borderLeft: '1.5px solid #e2e8f0',
  cursor: 'pointer',
  position: 'relative',
  flexShrink: 0,
  userSelect: 'none',
  minWidth: 90,
};

const flagStyle = {
  width: 22,
  height: 22,
  borderRadius: '50%',
  objectFit: 'cover',
  flexShrink: 0,
};

const currCodeStyle = {
  fontSize: '0.88rem',
  fontWeight: 700,
  color: '#0B214E',
};

const dropdownContainerStyle = {
  position: 'absolute',
  zIndex: 100,
  top: 'calc(100% + 4px)',
  right: 0,
  width: 200,
  background: '#fff',
  border: '1.5px solid #1e3a6e',
  borderRadius: '0.5rem',
  boxShadow: '0 4px 16px rgba(11,33,78,0.13)',
};

const dropdownItemStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '8px 12px',
  cursor: 'pointer',
  transition: 'background 0.12s',
  background: 'transparent',
};

const swapBtnStyle = {
  width: 38,
  height: 38,
  borderRadius: '50%',
  background: '#f1f5f9',
  border: '1.5px solid #e2e8f0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  fontSize: '1rem',
  color: '#0B214E',
  transition: 'background 0.15s, transform 0.25s',
  outline: 'none',
};

const convertBtnStyle = {
  width: '100%',
  height: 56,

  padding: '12px 24px',
  gap: 16,

  borderRadius: 12,

  background: '#D26521',

  boxShadow: '0px 8px 20px 0px #9E450829',

  color: '#fff',
  fontWeight: 700,
  fontSize: '1rem',

  border: 'none',
  cursor: 'pointer',

  opacity: 1,
  marginBottom: '1rem',
};

const securityNoteStyle = {
  height: 82,

  display: 'flex',
  alignItems: 'flex-start',
  gap: 16,

  padding: '8px 20px',
  borderRadius: 16,

  background:
    'linear-gradient(135deg, rgba(239, 246, 255, 0.8) 0%, rgba(238, 242, 255, 0.5) 100%)',

  border: '1px solid #bfdbfe',
  borderTop: '1px solid #BEDBFF4D',

  opacity: 1,
};

const spinnerStyle = {
  width: 16,
  height: 16,
  border: '2px solid #e2e8f0',
  borderTop: '2px solid #0B214E',
  borderRadius: '50%',
  animation: 'spin 0.7s linear infinite',
  display: 'inline-block',
};

export default DashboardTransferCalculator;